export const sliceKey = 'roughWork';
